/**
 * Stable fallback used when a validator returns an unexpected value.
 *
 * @since 0.1.0
 * @example
 * ```ts
 * const message = UNKNOWN_FORM_ERROR_MESSAGE;
 * ```
 */
export const UNKNOWN_FORM_ERROR_MESSAGE = "Unbekannter Formularfehler";

function hasMessage(value: unknown): value is { readonly message: unknown } {
  return typeof value === "object" && value !== null && "message" in value;
}

/**
 * Convert a TanStack Form validator error value into a stable display string.
 *
 * @since 0.1.0
 * @example
 * ```ts
 * const message = getFormErrorMessage({ message: "Required" });
 * ```
 */
export function getFormErrorMessage(error: unknown): string {
  if (typeof error === "string") {
    return error;
  }

  if (hasMessage(error)) {
    return String(error.message);
  }

  return UNKNOWN_FORM_ERROR_MESSAGE;
}
